import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./LoginPage/LoginPage.component";
import SignUpPage from "./SignUpPage/SignUpPage.component";
import ResultStepPage from "./ResultStepPage/ResultStepPage";
import HomePage from "./HomePage/HomePage.component";
import Home from "./HomePage/Home";
import ChatBot from "./ChatBot/ChatBot";
import UploadPage from "./UploadPage/UploadPage.component";
import CreateCollectionPage from "./CreateCollectionPage/CreateCollectionPage.component";
import NewCreateCollectionPage from "./NewCreateCollectionPage/NewCreateCollectionPage.component";
import AdminPage from "./AdminPage/AdminPage.component";
import UserPage from "./UserPage/UserPage.component";
import ResolutionPage from "./ResolutionPage/ResolutionPage.component";
import APIPage from "../pages-new/API/APIPage";
import Report from "./ReportPage/Report";
import Test from "./ReportPage/Test";
import ForgotPasswordPage from "./ForgotPasswordPage/ForgotPasswordPage.component";
import CoveragePage from "../components/CoveragePage/CoveragePage.component";
import Treestructure from "../components/CoveragePage/TreeStructure.component";
import TestData from "../components/TestData/TestData";
import CoverageDashboard from "../components/CoveragePage/CoverageDashboard.component";
import CreateTestCase from "../components/TestCase/CreateTestCase";
import ImpactAnalysis from "../components/GitHubPage/ImpactAnalysis";
import Recordings from "./RecordingPage/Recordings";
import { DasboadLayout } from "../components-new/layout";
import { TestStudio, ExecutionReports, Analytics, TestSuite, Dashboard } from "../pages-new";
import { ExecutionReportsHistory, StepHistoryPage, TestCaseReport } from "../pages-new/Reports";
import PaymentPage from "./PaymentPage/PaymentPage.component";
import ProfilePage from "./ProfilePage/ProfilePage.component";
import PaymentVerification from "./VerificationPage/VerificationPage.component";
import RankingPage from "./Rank/RankPage.component";
import PageConfiguration from "./PageConfiguration/PageConfiguration.component";
import PageElementsView from "./PageElements/PageElementsView.component";
import MobileAutomation from "../pages-new/Mobile/MobileAutomation";
import FailureAnalysisPage from "../pages-new/FailureAnalysis";
import TestDataPage from "../pages-new/TestData/TestDataPage";
import PublicTestResults from "../pages-new/PublicTestResults/PublicTestResults";
import TestCaseHistory from "../pages-new/Reports/TestCaseHistory";
import ApiSummary from "../pages-new/ApiSummary/ApiSummary";
import HelpCenter from "../pages-new/HelpCenter";
import Documentation from "../pages-new/Documentation";
import PublicsuiteResults from "../pages-new/PublicSuiteResults/PublicsuiteResults";
import Settings from "../pages-new/Settings/Settings";

const AppRouting = () => {
  let temp;
  try {
    const userDetails = localStorage.getItem("userDetail");
    temp = JSON.parse(userDetails);
  } catch (error) {
    console.error("Failed to parse user details from localStorage", error);
    temp = null;
  }

  const isUserAuthorized = temp !== null && temp?.email;
  const isCodeGen = temp?.company?.logintype === "codegen";

  const isPaymentCompleted =
    temp?.company?.plan && temp?.company?.plan?.available_credits > 0 ? true : false;

  const CodeGenPrivateRoute = ({ children }) => {
    if (!isUserAuthorized || !isCodeGen) {
      return <Navigate to={"/LoginPage"} />;
    }

    if (!isPaymentCompleted) {
      return <Navigate to={"/payment"} />;
    }
    return children;
  };

  const dashboardRoutes = [
    { path: "/dashboard/app", element: <HomePage /> },
    // {
    //   path: "/dashboard/app/productId/:pcid/testSuiteId/:tsid/resultSuiteId/:tsrid",
    //   element: <HomePage />,
    // },
    { path: "/dashboard/recording", element: <Recordings /> },
    { path: "/dashboard/upload", element: <UploadPage /> },
    { path: "/dashboard/createCollection", element: <CreateCollectionPage /> },
    { path: "/dashboard/newcreateCollection", element: <NewCreateCollectionPage /> },
    { path: "/dashboard/createTestCase", element: <CreateTestCase /> },
    { path: "/dashboard/repos", element: <ImpactAnalysis /> },
    { path: "/dashboard/AdminPage", element: <AdminPage /> },
    { path: "/dashboard/CoveragePage/:product", element: <CoveragePage /> },
    { path: "/dashboard/Screenshot/:ssid/:product", element: <Treestructure /> },
    { path: "/dashboard/CoverageDashboard", element: <CoverageDashboard /> },
    { path: "/dashboard/UserPage", element: <UserPage /> },
    { path: "/dashboard/userExperience", element: <ResolutionPage /> },
    { path: "/dashboard/testData", element: <TestData /> },
    { path: "/dashboard/api", element: <APIPage /> },
    { path: "/dashboard/Reports", element: <Report /> },
    { path: "/dashboard/Test", element: <Test /> },
    { path: "/dashboard/ResultStepPage/:tcid", element: <ResultStepPage /> },
    { path: "/dashboard/chatBot", element: <ChatBot /> },
  ];

  const newDashboardRoutes = [
    { path: "/new/dashboard", element: <Dashboard /> },
    { path: "/new/test-studio", element: <TestStudio /> },
    { path: "/new/reports", element: <ExecutionReports /> },
    { path: "/new/test-suites", element: <TestSuite /> },
    { path: "/new/analytics", element: <Analytics /> },
    { path: "/new/reports/history", element: <ExecutionReportsHistory /> },
    { path: "/new/dashboard/ResultStepPage/:tcid", element: <StepHistoryPage /> },
    { path: "/new/mobile", element: <MobileAutomation /> },
    { path: "/new/defect-analysis", element: <FailureAnalysisPage /> },
    { path: "/new/test-case-history", element: <TestCaseHistory /> },
    { path: "/new/api", element: <APIPage /> },
    { path: "/new/test-data", element: <TestDataPage /> },
    { path: "/new/api-summary", element: <ApiSummary /> },
    { path: "/new/help", element: <HelpCenter /> },
    { path: "/new/test-case-report", element: <TestCaseReport /> },
    {path: "/new/settings", element: <Settings />},
  ];

  // Add API routes outside of the /new prefix
  const apiRoutes = [
    { path: "/api", element: <APIPage /> },
    { path: "/genai", element: <APIPage /> },
  ];

  const codeGenRoutes = [
    {
      path: "/",
      element: (
        <CodeGenPrivateRoute>
          <Home />
        </CodeGenPrivateRoute>
      ),
    },
    {
      path: "/profile",
      element: (
        <CodeGenPrivateRoute>
          <ProfilePage />
        </CodeGenPrivateRoute>
      ),
    },
    {
      path: "/ranking",
      element: (
        <CodeGenPrivateRoute>
          <RankingPage />
        </CodeGenPrivateRoute>
      ),
    },
    {
      path: "/config",
      element: (
        <CodeGenPrivateRoute>
          <PageConfiguration />
        </CodeGenPrivateRoute>
      ),
    },
    {
      path: "/config/page-elements/:pageId",
      element: (
        <CodeGenPrivateRoute>
          <PageElementsView />
        </CodeGenPrivateRoute>
      ),
    },
  ];

  return (
    <Routes>
      {/* Public routes for test results */}
      <Route
        path="/dashboard/app/companyId/:companyId/testCaseId/:testCaseId/resultCaseId/:resultCaseId/token/:token"
        element={<PublicTestResults />}
      />
      <Route 
       path = "/dashboard/app/productId/:pcid/companyId/:companyId/testSuiteId/:tsid/resultSuiteId/:tsrid/token/:token"
       element={<PublicsuiteResults />}
       />

      {/* Documentation route - independent of dashboard layout */}
      <Route path="/new/documentation/*" element={<Documentation />} />

      <Route
        path="/"
        element={
          isUserAuthorized ? (
            isCodeGen ? (
              isPaymentCompleted ? (
                <Home />
              ) : (
                <Navigate to="/payment" />
              )
            ) : (
              <Navigate to="/new/dashboard" replace />
            )
          ) : (
            <Navigate to="/LoginPage" />
          )
        }
      />

      {/* Existing dashboard routes for non-codegen users */}
      {isUserAuthorized &&
        !isCodeGen &&
        dashboardRoutes.map((route, index) => (
          <Route key={index} exact path={route.path} element={route.element} />
        ))}

      {/* API routes */}
      {isUserAuthorized &&
        !isCodeGen &&
        apiRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}

      {/* Codegen routes */}
      {isUserAuthorized &&
        isCodeGen &&
        codeGenRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}

      {/* New dashboard routes - only for non-codegen users */}
      {isUserAuthorized && !isCodeGen ? (
        <Route path="/new" element={<DasboadLayout />}>
          <Route index element={<Dashboard />} />
          {newDashboardRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>
      ) : (
        <Route path="/new*" element={<Navigate to="/" />} />
      )}

      {/* Other routes */}
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/payment/verify" element={<PaymentVerification />} />
      <Route path="/LoginPage" element={<LoginPage />} />
      <Route path="/SignUpPage" element={<SignUpPage />} />
      <Route path="/SignUpPage?codegen=codegen" element={<SignUpPage />} />
      <Route path="/SignUpPage?cname=cname" element={<SignUpPage />} />
      <Route path="/ForgotPasswordPage" element={<ForgotPasswordPage />} />

      {/* Catch-all route */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRouting;
